import { type ReactNode, Children, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { i18n } = useTranslation();
  // isChanging: 実際に透明にするフラグ
  const [isChanging, setIsChanging] = useState(false);

  const arrayChildren = Children.toArray(children);
  const hero = arrayChildren[0]; 
  const content = arrayChildren.slice(1);

  useEffect(() => {
    // 1. 言語ボタンが押された瞬間にすぐ隠す
    setIsChanging(true);

    // 2. 0.1秒ほど待ってから、ふわっと戻し始める
    // この「待ち時間」の間にi18nの文字が入れ替わるので、
    // ユーザーには「古い文字が消えて、新しい文字が出てきた」ように見えます。
    const timer = setTimeout(() => {
      setIsChanging(false);
    }, 150); 

    return () => clearTimeout(timer);
  }, [i18n.language]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <style>{`
        .fade-target {
          /* 戻る（フェードイン）ときは少しゆっくり */
          transition: opacity 0.5s ease-in-out !important;
          opacity: 1;
        }
        .is-lang-changing .fade-target {
          /* 消える（フェードアウト）ときは一瞬で */
          transition: opacity 0.1s ease-in-out !important;
          opacity: 0;
        }
      `}</style>

      <Header />
      <main className={`flex-1 relative ${isChanging ? 'is-lang-changing' : ''}`}>
        <div style={{ position: 'sticky', top: 0, zIndex: 0 }}>
          {hero}
        </div>
        <div style={{ position: 'relative', zIndex: 10, backgroundColor: 'white' }}>
          {content}
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}